module.exports = __webpack_public_path__ + "img/hdd-network-fill.1e4ed32b.svg";